import React from 'react';
import classes from './CategoryFilterGroup.module.scss';
import classNames from 'classnames';
import { FilterItem } from '../FilterItem';
import { GetTimeslots_workspace_timeslots } from '../../../models/legacy-graphql';
import { TimeslotFilterType } from '../../../models/calendar';
import { CategoryType } from './CategoryFilterGroup.controller';
import { Debugger } from '../../containers/Debugger';

export type CategoryFilterGroupViewProps = {
  categories: CategoryType[];
  timeslots: GetTimeslots_workspace_timeslots[];
  loading: boolean;
  isMobile?: boolean;
  setSelectedFilter: (id: string) => void;
  filters: TimeslotFilterType;
};

export const CategoryFilterGroupView = (props: CategoryFilterGroupViewProps): JSX.Element => {
  const filterClasses = classNames(
    'grid-x',
    'grid-padding-x',
    'align-left',
    classes.CategoryFilterGroup,
    'align-middle'
  );
  const categoryTimeslotCount = (id: string): number =>
    props.timeslots.filter(timeslot => timeslot.category.id === id).length;

  const filterItems = props.categories.map(cat => {
    const categoryClasses = classNames(classes.ColorBar, classes[`ColorBar${cat.color}`]);
    const isSelected = cat.id === props.filters.categories;

    return (
      <FilterItem
        key={`categoryFilter.${cat.id}`}
        count={categoryTimeslotCount(cat.id)}
        selected={isSelected}
        loading={props.loading}
        setSelectedHandler={() => {
          props.setSelectedFilter(cat.id);
        }}>
        <div className={'relative'}>
          <Debugger tooltipContent={'Category ID: ' + cat.id} modalContent={cat} />
        </div>
        <div className={filterClasses}>
          <div className={categoryClasses} />
          <div className={`cell shrink ${classes.Label}`}>
            <p className={classes.CategoryName}>{cat.name}</p>
          </div>
        </div>
      </FilterItem>
    );
  });

  return <>{filterItems}</>;
};
